import React, { useEffect, useState } from "react";
import totLogo from "../../../assets/images/sbs/sbs_tot/logo_TOT.png";
import skipImg from "../../../assets/images/sbs/sbs_tot/skip-img.png";
import _ from "lodash";
import guesserImg from "../../../assets/images/sbs/sbs_tot/guesser-img.png";
import guesserBox from "../../../assets/images/sbs/sbs_tot/guesser-box.png";
import mvpOne from "../../../assets/images/sbs/sbs_tot/mvp-one.png";
import mvpTwoo from "../../../assets/images/sbs/sbs_tot/mvp-two.png";
import mvpThree from "../../../assets/images/sbs/sbs_tot/mvp-three.png";
import mvpTwo from "../../../assets/images/sbs/sbs_tot/mvp-two.png";
import { Button, Col, Row } from "reactstrap";
import mvpThreee from "../../../assets/images/sbs/sbs_tot/mvp-three.png";
import categoryImg from "../../../assets/images/sbs/sbs_tot/category.png";
import categoryFullImg from "../../../assets/images/sbs/sbs_tot/catg-img.png";
import host from "../../../assets/images/sbs/sbs_tot/host.png";
import guessedCard from "../../../assets/images/sbs/sbs_tot/guessed-box.png";
import skippedCard from "../../../assets/images/sbs/sbs_tot/skipped-box.png";
import userImgOne from "../../../assets/images/sbs/sbs_tot/one-mvp-avatar.png";
import { useSelector } from "react-redux";
import useWindowSize from "components/shared/WindowResize";

function Tot_Over({ users, tot_onPlayAgain, onHomeBtn }) {
  const { width } = useWindowSize();
  const [player_score, set_player_score] = useState([]);
  const [score_array, set_score_array] = useState([]);
  const [prevSkipWords, setPrevSkipWords] = useState(0);
  const [prevScoreWords, setPrevScoreWords] = useState(0);

  const gameState = useSelector(
    (state) => state.gameReducer?.roomObj?.game_state
  );

  const skippedWords = gameState?.skipped_words;
  const playerScore = gameState?.player_score;
  const right_words = _.get(gameState, "right_words");

  // const m = Math.max(...playerScore?.score);

  useEffect(() => {
    setPrevScoreWords(right_words.length);
    setPrevSkipWords(skippedWords.length);
  }, []);

  useEffect(() => {
    const score = [];
    users &&
      users.map((user) => {
        let count = 0;
        right_words.forEach((item) => {
          if (item.player_id === user.player_id) {
            count = count + 1;
          }
        });
        score.push({ ...user, score: count });
      });
    set_player_score(score);
  }, [right_words]);
  console.log(player_score, "player_scoreplayer_score");
  let players_with_max_score = [];
  let max_score = 0;
  player_score &&
    player_score.forEach((item) => {
      if (item.score > max_score) {
        max_score = item.score;
        players_with_max_score = [];
        players_with_max_score.push(item);
      } else if (item.score === max_score) {
        players_with_max_score.push(item);
      }
    });
  players_with_max_score.sort((a, b) => {
    return a.player_id - b.player_id;
  });
  console.log(
    players_with_max_score,
    "players_with_max_scoreplayers_with_max_score"
  );
  console.log(max_score, "max_scoremax_score");

  const final_Score =
    skippedWords.length > right_words.length
      ? 0
      : right_words.length - skippedWords.length;

  return (
    <>
      <Row>
        <Col lg={12} xl={12}>
          <img src={totLogo} className="sbs-tot-logo" alt="" />
        </Col>
      </Row>
      {/* <Row>
        <Col lg={8} xl={8}>
            <img src={skipImg} className="skipImg mt-2" alt="" />
          </Col>
      </Row> */}
      <Row>
        <Col lg={4} xl={4} className="offset-1">
          <div className="guessedCard">
            <img src={guessedCard} className="guessedCardImg" alt="" />
            <div className="guessed-num">
              <span>{gameState?.right_words.length}</span>
            </div>
            <div className="guessers">
              <div className="guessers-list">
                {gameState?.right_words &&
                  gameState?.right_words.length > 0 &&
                  gameState?.right_words?.map((item) => (
                    <div className="gue-name">
                      <p className="name">{item.word}</p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </Col>
        <Col lg={4} xl={4}>
          <div className="guessedCard">
            <img src={skippedCard} className="guessedCardImg" alt="" />
            <div className="skipped-num">
              <span>{gameState?.skipped_words.length}</span>
            </div>
            <div className="skippers">
              <div className="skippers-list">
                {gameState?.skipped_words &&
                  gameState?.skipped_words.length > 0 &&
                  gameState?.skipped_words?.map((item) => (
                    <div className="ski-name">
                      <p className="name">{item.word}</p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row className={width > 1850 ? "mt-4" : ""}>
        <Col lg={4} xl={4} className="offset-1">
          <div className="mvp-users">
            <>
              {players_with_max_score.length === 1 && (
                <div className="mvp-user-one">
                  <img
                    src={players_with_max_score[0].profile_image}
                    className="userImgOne"
                    alt=""
                  />
                  <div className="mvp-user-score-one">
                    <span>{final_Score}</span>
                  </div>
                </div>
              )}
              {players_with_max_score.length === 2 && (
                <div className="mvp-user-two">
                  <div className="d-flex align-items-centern justify-content-center">
                    <img
                      src={players_with_max_score[0].profile_image}
                      className="userImgTwo"
                      alt=""
                    />
                    <div className="mvp-user-score-two">
                      <span>{final_Score}</span>
                    </div>
                    <img
                      src={players_with_max_score[1].profile_image}
                      className="userImgTwo"
                      alt=""
                    />
                    <div className="mvp-user-score-two-numbers">
                      <span>{final_Score}</span>
                    </div>
                  </div>
                </div>
              )}
              {players_with_max_score.length === 3 && (
                <div className="mvp-user-three">
                  <div className="mvp-user-three-first">
                    <img
                      src={players_with_max_score[0].profile_image}
                      className="userImgOne"
                      alt=""
                    />
                    <div className="mvp-user-three-first-num">
                      <span>{final_Score}</span>
                    </div>
                  </div>
                  <div className="mvp-user-three-flex">
                    <img
                      src={players_with_max_score[1].profile_image}
                      className="userImgTwo"
                      alt=""
                    />
                    <div className="mvp-user-three-second-num">
                      <span>{final_Score}</span>
                    </div>
                    <img
                      src={players_with_max_score[2].profile_image}
                      className="userImgThree"
                      alt=""
                    />
                    <div className="mvp-user-three-third-num">
                      <span>{final_Score}</span>
                    </div>
                  </div>
                </div>
              )}
              {players_with_max_score.length === 1 && (
                <div className="one-mvp">
                  <img src={mvpOne} alt="" />
                  <p className="guesser">
                    {players_with_max_score[0].display_name.length > 15
                      ? players_with_max_score[0].display_name.slice(0, 15) +
                        "..."
                      : players_with_max_score[0].display_name}
                  </p>
                </div>
              )}
              {players_with_max_score.length === 2 && (
                <div className="two-mvp">
                  <img src={mvpTwoo} alt="" />
                  <p className="guesser">
                    {players_with_max_score[0].display_name.length > 15
                      ? players_with_max_score[0].display_name.slice(0, 15) +
                        "..."
                      : players_with_max_score[0].display_name}
                  </p>
                  <p className="guesser2">
                    {players_with_max_score[1].display_name}
                  </p>
                </div>
              )}
              {players_with_max_score.length === 3 && (
                <div className="three-mvp">
                  <img src={mvpTwoo} alt="" />
                  <p className="guesser">
                    {players_with_max_score[0].display_name}
                  </p>
                  <p className="guesser2">
                    {players_with_max_score[1].display_name}
                  </p>
                  <p className="guesser3">
                    {players_with_max_score[2].display_name}
                  </p>
                </div>
              )}
            </>
          </div>
        </Col>
        <Col lg={4} xl={4}>
          <div className="round-over-wrapper">
            <div className="round-over-text">
              <h2 className="text">Round Over!</h2>
              <h4 className="score">score:</h4>
            </div>
            <div className="round-over-circles">
              <div className="circle-green">
                <p className="txt">Guessed</p>
                <p className="num">{right_words.length}</p>
              </div>
              <span className="minus">-</span>
              <div className="circle-orange">
                <p className="txt">Skipped</p>
                <p className="num">{skippedWords.length}</p>
              </div>
              <span className="equal">=</span>
              <div className="circle-blue">
                <p className="txt">Score</p>
                <p className="num">{Math.abs(final_Score)}</p>
              </div>
            </div>
          </div>
          <div className="thanx-div">
            <h4>Thanks for playing!</h4>
            <div className="thanx-buttons">
              {/* <Button onClick={onHomeBtn} className="home-btn">
                home
              </Button> */}
              <Button onClick={tot_onPlayAgain} className="play-again-btn">
                play again?
              </Button>
            </div>
          </div>
        </Col>
        <Col lg={3} xl={3}>
          {/* <div className="host-img">
            <img src={host} className="img" alt="" />
          </div> */}
          <div className="host-img-round-over">
            <img src={host} className="img" alt="" />
          </div>
          {/* <div className="host-img-category">
              <img src={host} className="img" alt="" />
            </div> */}
        </Col>
      </Row>
      {/* <Row>
        <Col lg={4}>
          <div className="mvp-users">
            <div className="mvp-user-one">
                <img src={userImgOne} className="userImgOne" alt="" />
                <div className="mvp-user-score-one">
                  <span>10</span>
                </div>
              </div>
            <div className="mvp-user-two">
                <div className="d-flex align-items-centern justify-content-center">
                  <img src={userImgOne} className="userImgTwo" alt="" />
                  <div className="mvp-user-score-two">
                    <span>10</span>
                  </div>
                  <img src={userImgOne} className="userImgTwo" alt="" />
                  <div className="mvp-user-score-two-numbers">
                    <span>10</span>
                  </div>
                </div>
              </div>
            <div className="mvp-user-three">
              <div className="mvp-user-three-first">
                <img src={userImgOne} className="userImgOne" alt="" />
                <div className="mvp-user-three-first-num">
                  <span>10</span>
                </div>
              </div>
              <div className="mvp-user-three-flex">
                <img src={userImgOne} className="userImgTwo" alt="" />
                <div className="mvp-user-three-second-num">
                  <span>10</span>
                </div>
                <img src={userImgOne} className="userImgThree" alt="" />
                <div className="mvp-user-three-third-num">
                  <span>10</span>
                </div>
              </div>
            </div>
            <div className="one-mvp">
                <img src={mvpOne} alt="" />
                <p className="guesser">Giovanni Hernandez</p>
              </div>
            <div className="two-mvp">
                <img src={mvpTwoo} alt="" />
                <p className="guesser">Giovanni Hernandez</p>
                <p className="guesser2">Giovanni Hernandez</p>
              </div>
            <div className="three-mvp">
              <img src={mvpTwoo} alt="" />
              <p className="guesser">Giovanni Hernandez</p>
              <p className="guesser2">Giovanni Hernandez</p>
              <p className="guesser3">Giovanni Hernandez</p>
            </div>
          </div>
        </Col>
      </Row> */}
    </>
  );
}

export default Tot_Over;
